import { Box, Stack, SxProps, Typography } from '@mui/material';
import React, { useState } from 'react';
import { OpenInNew, Place } from '@mui/icons-material';
import { TabV2ButtonItem, TabsV2 } from 'common/ui/TabsV2';
import { SourcingSharedPreviewInvitationTab } from 'modules/sourcing-shared/components/SourcingSharedPreviewInvitationTab';
import { ReviewInvitationsCandidateItem } from 'modules/sourcing-shared/shared-steps/SourcingSharedReviewInvitationsStep';
import { SourcingExternalContactOutProfile } from 'modules/sourcing-external/components/SourcingExternalContactOutProfile';
import { Button } from 'system/atoms';
import { Channels } from 'generated-graphql/types';

const container: SxProps = {
  p: 3
};

type SourcingSharedEditInvitationDrawerProps = {
  candidate: ReviewInvitationsCandidateItem;
  channel: Channels;
  filledMessage: string;
  filledSubject: string | undefined;
  onUpdateInvitationMessage: (
    candidateId: string,
    customMessage: string
  ) => Promise<void>;
};

export enum TabsValue {
  PREVIEW_INVITATION = 'previewInvitation',
  PROFILE = 'profile'
}

const tabs = [
  {
    label: 'Preview invitation',
    value: TabsValue.PREVIEW_INVITATION
  },
  {
    label: 'Profile',
    value: TabsValue.PROFILE
  }
];

export const SourcingSharedEditInvitationDrawer: React.FC<
  SourcingSharedEditInvitationDrawerProps
> = ({
  candidate,
  channel,
  filledMessage,
  filledSubject,
  onUpdateInvitationMessage
}) => {
  const [tab, setTab] = useState<TabsValue>(TabsValue.PREVIEW_INVITATION);

  const linkedInProfileUrl = candidate.profile?.linkedInProfileUrl;
  const endItems: TabV2ButtonItem[] = linkedInProfileUrl
    ? [
        <Button
          key="viewLinkedInProfile"
          variant="tertiary"
          endIcon={<OpenInNew />}
          onClick={() => {
            window.open(linkedInProfileUrl, '_blank');
          }}
        >
          View LinkedIn profile
        </Button>
      ]
    : [];

  return (
    <Box sx={container}>
      <Stack direction="column" gap={2}>
        <Typography sx={{ fontSize: '30px', fontWeight: 400 }}>
          {candidate.fullName}
        </Typography>
        <Stack direction="row" gap={1} alignItems="center">
          <Stack direction="row" gap={0.5} alignItems="center">
            <Place fontSize="small" />
            <Typography>{candidate.location}</Typography>
          </Stack>
          <Typography>|</Typography>
          <Typography>{candidate.title}</Typography>
        </Stack>
        <TabsV2
          tabs={tabs}
          value={tab}
          onChange={(value) => setTab(value as TabsValue)}
          endItemsSx={{ mt: '10px' }}
          endItems={endItems}
        />
        {tab === TabsValue.PREVIEW_INVITATION && (
          <SourcingSharedPreviewInvitationTab
            channel={channel}
            subject={filledSubject}
            message={filledMessage}
            candidate={candidate}
            onUpdateInvitationMessage={onUpdateInvitationMessage}
          />
        )}
        {tab === TabsValue.PROFILE && candidate.profile && (
          <SourcingExternalContactOutProfile
            profile={candidate.profile}
            hideLinkedInLink
          />
        )}
      </Stack>
    </Box>
  );
};
